import { nextTick, ref } from 'vue'

const isSnackbarVisible = ref(false)
const snackbarMessage = ref<string | string[]>('')
const snackbarColor = ref<'cp-base-red' | 'cp-neutral-600'>('cp-neutral-600')
const snackbarTimeout = ref<number>(4000)

export const useSnackbar = () => {
	const showSnackbar = async (
		message: string | string[],
		color: 'cp-base-red' | 'cp-neutral-600' = 'cp-neutral-600',
		duration = 4000,
		persistent = false
	) => {
		if (isSnackbarVisible.value) {
			isSnackbarVisible.value = false
			await nextTick()
		}

		snackbarMessage.value = message
		snackbarColor.value = color
		snackbarTimeout.value = persistent ? -1 : duration
		isSnackbarVisible.value = true
	}

	const hideSnackbar = () => {
		isSnackbarVisible.value = false
	}

	return {
		isSnackbarVisible,
		snackbarMessage,
		snackbarColor,
		snackbarTimeout,
		showSnackbar,
		hideSnackbar
	}
}
